<template>
  <div>
    <!-- Cover Menu -->
    <el-container>
      <MenuHeader 
        :restaurant_uuid="restaurant_uuid" 
        :branch_uuid="branch_uuid" 
        :menu_data="MenuListAll" 
        :distance="DistanceBranch"  
        @toggle_search="toggle_search" 
        @toggle_branch_detail_drawer="toggleBranchDetailDrawer"
        :address="selectedLocation && selectedLocation.address" 
        @toggle_map="openLocationSelectionDrawer" 
        :fixedHeader="fixedHeader"
        :loading="loading"
      />
    </el-container>

    <!-- List Menu -->
		<Skeleton :loading="loading">
      <template #loading>
        <el-main class="menu-page" id="menu-page">
          <div class="menu-container">
            <div class="menu-group mb--7" v-for="(item) in [3, 4]" :key="item">
              <SkeletonItem variant="heading3" style="width: 70%;" />
              <div class="menu-list" v-for="(num) in item" :key="num">
                <el-row class="pb--0 d-flex">
                  <el-col :span="7">
                    <div 
                      class="color-gray95" 
                      style="
                        border-radius: 6px; 
                        width: 90%; 
                        height: 100%;
                        min-height: 80px;
                      "
                    />
                  </el-col>
                  <el-col :span="14">
                    <SkeletonItem variant="heading3" style="width: 60%;" />
                    <SkeletonItem variant="body" style="width: 80%;" />
                  </el-col>
                  <el-col :span="3">
                    <SkeletonItem variant="heading3" />
                  </el-col>
                </el-row>
              </div>
              <div class="category-bottom-bar" />
            </div>
            <MenuFooter />
          </div>
        </el-main>
      </template>

      <!-- Menu list -->
      <template>
        <el-main class="menu-page" id="menu-page" :style="`top: ${topPosition}px;`">
          <div class="menu-container" v-if="menuGroups.length" >
            <el-col v-if="BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00'" class="fs-vat pa--2">
              <div class="d-flex align-center">
                <i class="el-icon-warning-outline" /> 
                <span class="text-subtitle--med ml--1">
                  {{ $t('pageMenuList.tax.title') }} 
                  {{ BranchDetail.tax | priceFormat }} %
                </span>
              </div>
            </el-col>
            <MenuGroup
              v-for="(category,index) in MenuListAll"
              :groupindex="index"
              :key="'category-'+index"
              :restaurant_uuid="restaurant_uuid"
              :branch_uuid="branch_uuid"
              :category="category"
              :menu_data="category.menus"
            />
            <MenuFooter />
          </div>
          <div v-else class="text-xs-center py--7">
            <img :src="require('@/assets/icons/svg/empty-menu.svg')" />
            <h4 class="text-title--large ma--0 pt--3 color-mineshaft--text">{{ $t('pageMenuList.menu.emptyMenu') }}</h4>
            <p class="text-subtitle color-smokegray--text ma--0 pt--1">{{ $t('pageMenuList.menu.emptyMenu2') }}</p>
          </div>

          <div v-if="amountCart > 0">
            <MenuCartBtn 
              @toggle_dialog="toggle_dialog" 
              :badge="amountCart" 
              :distance="distance" 
              :deliveryFee="deliveryFee" 
              @click.native="checkoutToCart"
            />
            <!-- Dialog Suggestion -->
            <Dialog
              v-if="isOpenDialog && !isOpenPreorderDialog && DisplayDialogPreorder"
              @toggleDialog="toggleDialog"
              :dialogConfirm="false"
              :dialogTitle="dialogTitle"
              :dialogText="dialogText"
              :dialogSrc="dialogSrc"
              :dialogRedirect="[]"
              :btnText="$t('pageMenuList.header.close')"
            />
          </div>
        </el-main>
      </template>
    </Skeleton>

    <!-- Search Menu List -->
    <SearchBtn
      v-if="is_search"
      :restaurant_uuid="restaurant_uuid"
      :branch_uuid="branch_uuid"
      :category_data="MenuListAll"
      @toggle_search="toggle_search"
    />

    <!-- Dialog Map Drawer -->
    <!-- <MapDrawer 
      v-show="BranchDetail.deliveryFlag === '1'" 
      v-if="is_map" 
      :is_map="is_map"  
      @toggle_search="toggle_map" 
    /> -->

    <LocationSettingDrawer 
      v-model="isLocationSettingDrawerOpen"
      @use:current="useCurrentLocation"
      @use:custom="openLocationSelectionDrawer"
    />

    <LocationSelectionDrawer 
      v-model="isLocationSelectionDrawerOpen"
      :location="selectedLocation || branchLocation"
      @submit="onSelectLocation"
    />

    <!-- Dialog Preorder -->
    <Dialog
      v-if="isOpenPreorderDialog"
      :dialogConfirm="false"
      :dialogTitle="dialogPreorderTitle"
      :dialogText="dialogPreorderText"
      :dialogSrc="dialogPreorderSrc"
      :dialogRedirect="[]"
      :btnText="dialogPreorderBtn"
    />

    <BranchDetailDrawer 
      v-model="isBranchDetailDrawerOpen"
      :branch-detail="BranchDetail"
      :receiving-type="flagReciveOrder"
      :distance-info="distanceInfo"
    />
  </div>
</template>
<script>
import Mixins from '@/utils/mixins'
import { beforeRoute } from '@/router/beforeRoute'

import MenuGroup from '@/components/menu/MenuGroup'
import MenuCartBtn from '@/components/menu/MenuCartBtn'
import MenuHeader from '@/components/menu/MenuHeader'
import MenuFooter from '@/components/menu/MenuFooter'
import SearchBtn from '@/components/search/SearchBtn'
import MapDrawer from '@/components/map/MapDrawer'
import Dialog from '@/components/dialog/Dialog'
import BranchDetailDrawer from "@/components/menu/BranchDetailDrawer"
import LocationSettingDrawer from '@/components/locationsetting/LocationSettingDrawer.vue'
import LocationSelectionDrawer from '@/components/locationselection/LocationSelectionDrawer.vue'

export default {
  name: 'MenuList',
  components:{
    MenuGroup,
    MenuCartBtn,
    MenuHeader,
    SearchBtn,
    MapDrawer,
    Dialog,
    MenuFooter,
    BranchDetailDrawer,
    LocationSelectionDrawer,
    LocationSettingDrawer
  },
  props: ['restaurant_uuid', 'branch_uuid'],
  mixins: [Mixins],
  data () {
    return {
      distance: 0,
      deliveryFee: 0,
      is_search: false,
      is_map: false,
      address: '',
      fixedHeader: false,
      isOpenDialog: false,
      dialogTitle: '',
      dialogText: '',
      dialogSrc: '',
      isOpenPreorderDialog: false,
      dialogPreorderTitle: '',
      dialogPreorderText: '',
      dialogPreorderSrc: '',
      dialogPreorderBtn: '',
      loop: 0,
      restaurantUUID: '',
      branchUUID: '',
      loading: false,
      isBranchDetailDrawerOpen: false,
      isLocationSelectionDrawerOpen: false,
      isLocationSettingDrawerOpen: false,
      selectedLocation: null
    }
  },
  beforeRouteEnter: async function(to, from, next) {
    return next(vm => vm.beforeRoute = () => beforeRoute(to, from, next))
  },
  created() {
    document.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  mounted: async function() {
    try {
      this.loading = true
      await this.beforeRoute()
      await Promise.all([
        this.initialStates(),
        this.initDialogPreoder()
      ])
      const userLocation = JSON.parse(localStorage.getItem('fsloc') || '{}')
			const hasLocation = Number.isFinite(userLocation.lat) && Number.isFinite(userLocation.lng)
      if (hasLocation) {
				this.selectedLocation = userLocation
        this.updateDistanceInfo(this.selectedLocation)
			} else {
				this.isLocationSettingDrawerOpen = true 
			}
    } finally {
      this.loading = false
    }
  },
  methods: {
    initialStates: async function() {
      return Promise.all([
        this.$store.dispatch('setKeyToLacalStorage', {
          restaurant_uuid: this.BranchDetail.restaurantId,
          branch_uuid: this.BranchDetail.id,
          restaurantAlias: this.restaurant_uuid,
          branchAlias: this.branch_uuid
        }),
        this.$store.dispatch('getMenuListByBranch', {
          restaurant_uuid: this.BranchDetail.restaurantId,
          branch_uuid: this.BranchDetail.id
        })
      ])
    },
    initDialogPreoder: function() {
      const preorder = this.preorderDetail
      if (!preorder) return
      if (!preorder.deliveryTime.isOpen && preorder.orderNowSetting.orderNowFlag && preorder.preOrderSetting.preorderFlag ||
      !preorder.deliveryTime.isOpen && !preorder.orderNowSetting.orderNowFlag && preorder.preOrderSetting.preorderFlag) {
        // CASE Preorder 3,4 Phase 3.0
        if (!this.DisplayDialogPreorder) {
          this.$store.dispatch('setDisplayDialogPreorder', true)
          this.isOpenPreorderDialog = true
          this.dialogPreorderTitle = this.$t('dialog.preorder.title2')
          this.dialogPreorderText = this.getPreorderNextTimeText(preorder)
          this.dialogPreorderSrc = 'icons/preorder.png'
          this.dialogPreorderBtn = this.$t('dialog.preorder.btnpreorder')
        }
      } else if (preorder.deliveryTime.isOpen && preorder.preOrderSetting.preorderFlag && !preorder.orderNowSetting.orderNowFlag) {
        // CASE Preorder 2 Phase 3.0
        if (!this.DisplayDialogPreorder) {
          this.$store.dispatch('setDisplayDialogPreorder', true)
          this.isOpenPreorderDialog = true
          this.dialogPreorderTitle = this.$t('dialog.preorder.title3')
          this.dialogPreorderText = this.$t('dialog.preorder.descript1')
          this.dialogPreorderSrc = 'icons/preorder.png'
          this.dialogPreorderBtn = this.$t('dialog.preorder.btnpreorder')
        }
      } else if (!preorder.deliveryTime.isOpen && !preorder.preOrderSetting.preorderFlag && preorder.orderNowSetting.orderNowFlag) {
      // CASE Preorder 7 Phase 3.0
        this.$store.dispatch('setDisplayDialogPreorder', false)
        this.isOpenPreorderDialog = true
        this.dialogPreorderTitle = this.$t('dialog.branchclose.title')
        this.dialogPreorderText = this.getPreorderNextTimeText(preorder)
        this.dialogPreorderSrc = 'icons/restaurant_close.png'
        this.dialogPreorderBtn = this.$t('dialog.close')
      } else {
        this.$store.dispatch('setDisplayDialogPreorder', true)
      }
    },
    useCurrentLocation: function(location) {
      return this.updateLocation(location)
		},
    openLocationSelectionDrawer: function() {
      this.isLocationSelectionDrawerOpen = true
    },
    onSelectLocation: async function({ location, done }) {
      try {
        await this.updateLocation(location)
      } finally {
        done(true)
      }
    },
    updateLocation: async function(location) {
      this.selectedLocation = Object.assign({}, this.selectedLocation, location)
      this.checkDupLocation()
      localStorage.setItem('fsloc', JSON.stringify(this.selectedLocation))
      const updatedLocation = JSON.parse(localStorage.getItem('fsloc'))
      await this.updateDistanceInfo(updatedLocation)
    },
    checkDupLocation () {
      const locationFromStore = JSON.parse(localStorage.getItem('fsloc'))
      const isOldLocation = 
        locationFromStore &&
        locationFromStore.lat == this.selectedLocation.lat && 
        locationFromStore.lng == this.selectedLocation.lng
       if (isOldLocation) {
        this.selectedLocation.new = 0
      } else {
        this.selectedLocation.new = 1
      }
      return this.$store.dispatch('setChangeLocation', {
        status: this.selectedLocation.new == 0 ? 'old' : 'first',
        branch: this.BranchDetail,
        location: this.selectedLocation
      })
    },
    updateDistanceInfo: async function(fromLocation) {
      if (!fromLocation) return
      const distance = await this.$store.dispatch('calculateDistance', {
        origin_coordinates: [this.BranchDetail.latitude, this.BranchDetail.longitude],
        origin_address: this.BranchDetail.address,
        destination_address: fromLocation.address,
        destination_coordinates: [fromLocation.lat, fromLocation.lng]
      })
      const distanceInfo = await this.$store.dispatch('getDistanceInfo', {
        distance,
        total: this.TotalCartPrice,
        location: fromLocation,
        restaurant: this.BranchDetail.restaurantId,
        branch: this.BranchDetail.id
      })
      return distanceInfo
    },
    toggleBranchDetailDrawer: function() {
      this.isBranchDetailDrawerOpen = !this.isBranchDetailDrawerOpen
    },
    toggleDialog () {
      this.isOpenDialog = !this.isOpenDialog
    },
    toggle_dialog (value) {
      let receive = JSON.parse(localStorage.getItem('send-' + this.BranchDetail.id))
      if (value.ChangeLocation === null) {
        this.loop++
        if (this.loop == 1 && receive == 'delivery') {
          let location = JSON.parse(localStorage.getItem('fsloc'))
          if (location !== null && typeof location !== 'undefined') {
            // console.log(this.DistanceInfo)
            // if (this.DistanceInfo === null) {
            this.$store.dispatch('setChangeLocation', {
              status: 'old',
              branch: this.BranchDetail,
              location: { lat: location.lat, lng: location.lng, address: location.address, new: 0}
            })
            // }
          }
        }
      } else {
        if (receive == 'delivery') {
          if ((this.TotalCartPrice >= this.SuggestionDetail.totalFree && this.SuggestionDetail !== null)) {
            if (this.displayDialogSuggestion == false) {
              this.isOpenDialog = true
            } else if (value.display == true) {
              this.isOpenDialog = true
            }
            this.$store.commit('setdisplayDialogSuggestion', true)
          } else {
            if (value.display) {
              this.isOpenDialog = true
              this.$store.commit('setdisplayDialogSuggestion', false)
            } else {
              this.isOpenDialog = false
              this.$store.commit('setdisplayDialogSuggestion', false)
            }
          }
          this.dialogSrc = value.src
          this.dialogTitle = value.title
          this.dialogText = value.text
          let location = {
            lat: value.ChangeLocation.location.lat,
            lng: value.ChangeLocation.location.lng,
            address: value.ChangeLocation.location.address,
            new: 0
          }
          localStorage.setItem('fsloc', JSON.stringify(location))
        }
      }
    },
    handleScroll() {
      const category = document.getElementById('tab-category')
      const sticky = category.offsetTop
      if (window.pageYOffset > this.topPosition) {
        this.fixedHeader = true
        category.classList.add('fs-sticky-category')
      } else {
        this.fixedHeader = false
        category.classList.remove('fs-sticky-category')
      }
    },
    routeToMenuDetail (menu_uuid) {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/menu/${menu_uuid}` })
    },
    toggle_search (){
        this.is_search = !this.is_search;
    },
    toggle_map (){
        this.is_map = !this.is_map;
    },
    checkoutToCart () {
      if (!this.DisplayDialogPreorder) {
        this.$router.go(0)
      } else {
        this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/checkout` })
      }
    },
    openLink (link) {
      window.open(link)
    },
    getPreorderNextTimeText (preorder) {
      if (preorder.deliveryTime.timePeriod.length > 0) {
        return `${this.$t('dialog.preorder.title1')} ${this.$t('dialog.preorder.today')} ${preorder.deliveryTime.timePeriod[0].openTime}`
      } else {
        let parts = preorder.nextDeliveryTime.deliveryDate.split('/')
        let date = new Date(parts[2], parts[1] - 1, parts[0])
        if (this.isTodayFormat(date)) {
          return `${this.$t('dialog.preorder.title1')} ${this.$t('dialog.preorder.today')} ${preorder.nextDeliveryTime.openTime}`
        } else {
          let text = `${this.$t('dialog.preorder.title1')} ${this.filter_long_day_th(preorder.nextDeliveryTime.dayId)} ${preorder.nextDeliveryTime.openTime}`
          if (this.$i18n.locale === 'en') {
            text = `${this.$t('dialog.preorder.title1')} ${this.filter_long_day_en(preorder.nextDeliveryTime.dayId)} ${preorder.nextDeliveryTime.openTime}`
          }
          return text
        }
      }
    },
  },
  computed: {
    topPosition: function() {
      const hasAllService = this.BranchDetail.deliveryFlag == 1 && this.BranchDetail.pickupFlag == 1
      return hasAllService ? 390 : 360
    },
    branchLocation: function() {
			const { latitude, longitude } = this.BranchDetail || {}
			const hasLocation = Number.isFinite(latitude) && Number.isFinite(longitude)
			return hasLocation ? { lat: latitude, lng: longitude } : {}
		},
    distanceInfo: function() {
      return this.$store.getters.DistanceInfo
    },
    flagReciveOrder: function() {
      return this.$store.getters.flagReciveOrder
    },
    menuGroups: function() {
      return this.MenuListAll.filter(({ menus = [] }) => menus.length)
    },
    MenuListAll () {
      return this.$store.getters.MenuListAll || []
    },
    amountCart: function() {
      return this.$store.getters.AmountCart.reduce((acc, item) => {
        acc += item.qty
        return acc
      }, 0)
    },
    OldTotalCartPrice () {
      return this.$store.getters.OldTotalCartPrice
    },
    TotalCartPrice () {
      return this.$store.getters.TotalCartPrice
    },
    BranchDetail () {
      return this.$store.getters.BranchDetail || {}
    },
    preorderDetail: function () {
      return this.$store.getters.PreOrderDetail
    },
    SuggestionDetail () {
      return this.$store.getters.SuggestionDetail
    },
    ChangeLocation () {
      return this.$store.getters.ChangeLocation
    },
    displayDialogSuggestion () {
      return this.$store.getters.displayDialogSuggestion
    },
    DisplayDialogPreorder () {
      return this.$store.getters.DisplayDialogPreorder
    },
    DistanceBranch () {
      return this.$store.getters.DistanceBranch
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/menu/MenuList.vue